export const setDashboardItemSelected = item => ({
  type: 'SET_IS_DASHBOARD_ITEM_SELECTED',
  payload: item,
});
